let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3di40")).then(() => parcelRequire('d2HAI'));